//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let titleFontSize = '5rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
		titleFontSize = '3rem';
	}
	//#endregion

	return {
		outerStyle: ({BGImage}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				height: `100vh`,
				backgroundImage: `url(${BGImage})`,
				backgroundPosition: 'center',
				backgroundSize: 'cover',
				padding: `3rem ${minimumMarginX}rem`,
			};
		},
		floaterStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				width: 'auto',
				height: 'auto',
				margin: 'auto',
			};
		},
		titleStyle: ({isFirst}) => {
			let marginTopAmount = isFirst ? 0 : 1;
			return {
				margin: `${marginTopAmount}rem auto 0 auto`,
				fontSize: titleFontSize,
				textAlign: 'center',
			};
		},
		genericTextStyle: () => {
			return {
				color: 'white',
				margin: '1rem auto',
				textAlign: 'center',
			};
		},
	};
}

export default Styles;
